import React, {  Component } from 'react';

export default class ConfirmRejectUserRequestDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog("ConfirmRejectUserRequestDialog", false);
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmRejectUserRequestDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Confirm Reject User Request</h2>
					<p className="bold">Are you sure you want to reject this user?</p>
					<p><b>{this.props.firstName} {this.props.lastName}</b></p>
                    <a className="blueButton noButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
					<a className="blueButton yesButton" onClick={this.props.handleApproveOrRejectServiceCall.bind(this, "Rejected")}>Yes</a>
                 </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmRejectUserRequestDialog.js